import React from "react";
import { withTranslation } from "react-i18next";
import Homepage from "./homepage";

const IndexPage = () => <Homepage />;

export default withTranslation()(IndexPage);
